import { divIcon } from "leaflet";

const PIN_PATH =
  "M128,16a88.1,88.1,0,0,0-88,88c0,75.3,80,132.17,83.41,134.55a8,8,0,0,0,9.18,0C136,236.17,216,179.3,216,104A88.1,88.1,0,0,0,128,16Zm0,56a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z";

/** Leaflet marker icon of the storefront pin, filled with the palette `danger` colour. */
export const mapPinIcon = divIcon({
  className: "custom-pin",
  html: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" style="fill:rgb(var(--color-danger))" viewBox="0 0 256 256"><path d="${PIN_PATH}"></path></svg>`,
  iconSize: [40, 50],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
});

/** Resolves a palette role (e.g. `danger`) to a CSS colour string for Leaflet path options. */
export function paletteColor(role: "danger" | "success"): string {
  const channels = getComputedStyle(document.documentElement).getPropertyValue(`--color-${role}`).trim();
  return `rgb(${channels})`;
}
